import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import axios from "axios";
import {Dialog} from "primereact/dialog";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import '../../css/DataTableDemo.css'
import {TreeTable} from 'primereact/treetable';


const CmsPageList = props => {
    const toast = useRef(null);
    const [cipList, setCipList] = useState([]);
    const [cipDeleteDialog, setCipDeleteDialog] = useState(false);
    const [introId, setIntroId] = useState(null);


    const page_list_role = localStorage.getItem('report_list') ? true : false;


    useEffect(() => {

        getIntroPages()


    }, []); //Buradaki dizi içine yazılan değer, değişince useeffecti çalıştır.


    const getIntroPages = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('/api/intro_page/', {"headers": headers})
            .then(res => {
                setCipList(res.data)
            })
    }
    const selectPages = (cip_id) => {
        const url = "/intro-page/update/" + cip_id + "/";
        window.location.hash = url
    }
    const selectPagesAdd = (cip_id) => {
        const url = "/intro-page/sub-intropage/" + cip_id + "/";
        window.location.hash = url
    }


    const renderFooter = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setCipDeleteDialog(false)}
                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={() => deleteCip(introId)} autoFocus/>
            </div>
        );
    }


    const deleteRow = (cipID) => {


        setCipDeleteDialog(true)
        setIntroId(cipID)


    }
    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            detail: message,
            life: 3000
        });
    }


    const deleteCip = (cipID) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.delete('/api/intro_page' + `/${cipID}/`, {"headers": headers})
            .then(res => {

                const data = res.data;
                if (data.result) {

                    showSuccess(data.message);
                } else {
                    showError(data.message);
                }


                getIntroPages();

                setCipDeleteDialog(false)
                setIntroId(null)

            });


    };


    const actionTemplate = (rowData) => {
        return <div>

            <Button className="p-button-link  p-mr-3" icon="pi pi-search"
                    style={{background: 'lightskyblue', maxHeight: '2em', maxWidth: '2em'}}
            />


            <Button
                type="submit"
                title="Düzenle"
                icon="pi pi-pencil"
                className="p-button-warning p-mr-3"
                onClick={() => selectPages(rowData['data']['cip_id'])}
                style={{maxHeight: '2em', maxWidth: '2em'}}
            >
            </Button>
            <Button
                type="submit"
                title="Sil"
                icon="pi pi-trash"
                className="p-button-danger p-mr-3"
                onClick={() => deleteRow(rowData['data']['cip_id'])}
                style={{maxHeight: '2em', maxWidth: '2em'}}
            >
            </Button>


        </div>;
    }
        const actionTemplate2 = (rowData) => {
        return <div>
            <Button icon="pi pi-plus" className="p-button-rounded p-button-success p-mr-3"
                    onClick={() => selectPagesAdd(rowData['data']['cip_id'])}
            />



        </div>;
    }


    const createNewContent = () => {
        window.location.hash = '/intro-page'
    }




    if (page_list_role) {


        return (

            <div>


                <Toast ref={toast}/>

                <Dialog header="UYARI" visible={cipDeleteDialog}
                        style={{width: '20%'}}
                        footer={renderFooter()}

                        onHide={() => setCipDeleteDialog(false)}>
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>Silmek İstediğinizden Emin Misiniz?</span>
                    </div>


                </Dialog>
                <Button label="Yeni Sayfa  Ekle" icon="pi pi-plus" className="p-button-success p-mb-5"
                        onClick={createNewContent} style={{width: '150px', height: '35px'}}/>

                <div className="datatable-responsive-demo">

                    <div className="card">
                        <h5><b>Tanıtım Sayfaları</b></h5>
                        <p>Sayfalandırma, sıralama ve filtreleme </p>
                        <TreeTable value={cipList['root']}
                                   style={{marginTop: '.5em'}}
                                   emptyMessage="Kayıt Bulunamadı."
                                   paginator
                                   rows={10}

                        >
                            <Column
                                body={actionTemplate2}
                                style={{textAlign: 'center', width: '5em',}}
                            />


                            <Column
                                field={'cip_menuname'}
                                header="Menü Adı"
                                filter
                                sortable
                                expander
                                style={{fontWeight: 'bold'}}


                            />

                            <Column
                                field={'cip_title'}
                                header="Başlık"
                                filter
                                sortable

                                style={{textAlign: 'center'}}/>
                            <Column
                                field={'md_name'}
                                style={{width: '25em', textAlign: 'center', fontWeight: 'bold'}}
                                header="Modül Adı"
                                sortable
                                filter


                            />
                            <Column
                                field={'cip_createtime'}
                                header="Oluşturulma Zamanı"
                                filter
                                sortable

                                style={{textAlign: 'center'}}/>
                            <Column
                                field={'cip_updatetime'}
                                header="Güncellenme Zamanı"
                                filter
                                sortable
                                style={{textAlign: 'center', fontWeight: 'bold'}}/>

                            <Column
                                header="İşlevler"
                                body={actionTemplate}
                                style={{textAlign: 'center', width: '15em'}}
                            />
                        </TreeTable>

                    </div>
                </div>
            </div>


        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}
export default CmsPageList;


// WEBPACK FOOTER //
// ./src/pages/cmsmanagement/CmsPageList.jsx